<template>

    <div 
        @mouseover="showBlockActionButtons = true" 
        @mouseleave="showBlockActionButtons = false" 
        >

        <div v-if="showBlockActionButtons" :id="settingsToShow+'-tooltip-delete'" class="delete-child-icon" @click="confirmBlockDelete = true">
            <i class="fas fa-times"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons" :target="settingsToShow+'-tooltip-delete'">
            <div class="delete-block-tooltip">Delete</div>
        </b-tooltip>

        <div class="confirm-block-deletion" v-if="confirmBlockDelete">
            <h4>Permanent Action</h4>
            <p>Are you sure you want to delete this block?</p>
            <span @click="deleteChildBlock(arrayIndex)" class="confirm-delete-block-action">
                <i class="far fa-trash-alt"></i>Yes, delete.
            </span>
            <span @click="confirmBlockDelete = false">
                <i class="fas fa-ban"></i>Cancel.
            </span>
        </div>

        <div v-if="showBlockActionButtons" class="settings-child-icon" @click="showChildBlockSettings(settingsToShow)" :id="settingsToShow+'-tooltip-settings'">
            <i class="fas fa-cog"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons" class="access-settings-tooltip" :target="settingsToShow+'-tooltip-settings'">
            <div class="access-settings-tooltip">Settings</div>
        </b-tooltip>

        <div class="block-drag-handle" v-if="showBlockActionButtons && !deviceStylesSetttings.tabletStyles && !deviceStylesSetttings.mobileStyles">
            <i class="fas fa-ellipsis-h"></i>
        </div>

        <div class="block-drag-handle-disabled" v-if="showBlockActionButtons && (deviceStylesSetttings.tabletStyles || deviceStylesSetttings.mobileStyles)" v-b-tooltip.hover.top title="Switch to desktop view to re-position blocks">
            <i class="fas fa-ellipsis-h"></i>
        </div>

        <div v-if="showBlockChildSettingsGuide" class="settings-box-child-guide" :id="'child-block-settings-'+settingsToShow+'-guide'"></div>
        <transition name="slide-fade">

            <vue-draggable-resizable 
            :resizable="false" 
            :drag-handle="'.settings-box-child-title'"
            :w="setBoxWidth" :h="setBoxHeight" :z="999" 
            class="settings-box-child" 
            v-if="showChildSettings" 
            :x="centerPositionSettingsBoxX"
            :y="centerPositionSettingsBoxY"

            :id="'child-block-settings-'+settingsToShow">
                <!-- settings group: CHILD BLOCKS -->
                <div class="settings-box-child-title">
                    <h6>block settings</h6>
                </div>

                <div class="settings-box-child-inner">

                    <div>

                        <div v-show="deviceStylesSetttings.desktopStyles">
                            <!-- visibility settings -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>visibility</h6>
                                </div>
                                <div class="setting-section-content">
                                    <!-- hide on desktop toggle -->
                                    <div class="setting">
                                        <b-form-checkbox switch v-model="childBlock.hideOnDesktop" name="hide-childblock-on-desktop">
                                            Hide on desktop
                                        </b-form-checkbox>
                                    </div> 
                                </div>
                            </div>

                            <!-- styles settings -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>styles</h6>
                                </div>
                                <div class="setting-section-content">

                                    <!-- label background type -->
                                    <label>Select background type:</label>
                                    <!-- background type child -->
                                    <div class="setting setting-toggle-group" v-if="clientPro=='PRO'">
                                        <b-form-checkbox switch v-model="childBlock.backgroundColorChild"  @change="useBackgroundColor(arrayIndex)">
                                            Background color
                                        </b-form-checkbox>
                                    
                                        <b-form-checkbox switch v-model="childBlock.backgroundImageChild" @change="useBackgroundImage(arrayIndex)">
                                            Background image
                                        </b-form-checkbox>
                                    
                                        <b-form-checkbox switch v-model="childBlock.backgroundVideoChild" @change="useBackgroundVideo(arrayIndex)">
                                            Background video (Vimeo or Youtube)
                                        </b-form-checkbox>
                                        
                                    </div>

                                    <!-- background type child -->
                                    <div class="setting pro-setting setting-toggle-group" v-if="clientPro!=='PRO'"  v-b-tooltip.hover.top title="PRO feature" v-b-modal="'upgrades-modal'">
                                        <b-form-checkbox switch >
                                            Background color
                                        </b-form-checkbox>
                                    
                                        <b-form-checkbox switch >
                                            Background image
                                        </b-form-checkbox>
                                    
                                        <b-form-checkbox switch >
                                            Background video (Vimeo or Youtube)
                                        </b-form-checkbox>
                                        
                                    </div>


                                    <!-- background color picker child -->
                                    <div class="setting" v-if="childBlock.backgroundColorChild">
                                        <Mycolorpickerchildblocks elementRef="childBackground" theColorPicker="allpickers" colorPickerName="Select background color:" :indexNr="arrayIndex" />
                                    </div><!-- v-if="childBlock.backgroundColorChild -->

                                    <!-- background image child -->
                                    <div v-if="childBlock.backgroundImageChild">

                                        <!-- upload bg -->
                                        <div class="setting">
                                            <label>Upload background image:</label>
                                            <b-form-file name="image_field" @change="onFileSelected(arrayIndex)" accept="image/*" />
                                        </div>

                                        <!-- background position axis -->
                                        <div class="setting">
                                            <b-form-group>

                                                <label>Image position x axis:</label>
                                                <b-form-select v-model="childBlock.xAxisPosition" size="sm">
                                                    <option value="left">Left</option>
                                                    <option value="center">Center</option>
                                                    <option value="right">Right</option>
                                                </b-form-select>

                                            </b-form-group>
                                        </div>

                                        <!-- background position y axis -->
                                        <div class="setting">
                                            <b-form-group>

                                                <label>Image position y axis:</label>
                                                <b-form-select v-model="childBlock.yAxisPosition" size="sm">
                                                    <option value="top">Top</option>
                                                    <option value="center">Center</option>
                                                    <option value="bottom">Bottom</option>
                                                </b-form-select>

                                            </b-form-group>
                                        </div>

                                        <!-- parallax toggle -->
                                        <div class="setting">
                                            <label>Parallax effect:</label>
                                            <b-form-checkbox switch v-model="childBlock.useParallax" @change="activateParallaxToggle">
                                                Activate effect
                                            </b-form-checkbox>
                                        </div>

                                        <!-- parallax speed -->
                                        <div class="setting" v-if="childBlock.useParallax">
                                            <b-form-group>

                                                <label for="flexchild-parallaxspeed-input">Parallax speed: <span v-b-tooltip.hover.top title="set value between '-1.0' and '2.0'"><i class="far fa-question-circle"></i></span></label>
                                                
                                                <b-input-group size="sm">
                                                    <b-form-input id="flexchild-parallaxspeed-input" type="number" v-model="childBlock.parallaxSpeed" min="-1.0" max="2.0" step="0.1" @change="activateParallaxToggle" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>   


                                    </div><!-- v-if="childBlock.backgroundImageChild" -->

                                    <!-- background video child -->
                                    <div v-if="childBlock.backgroundVideoChild">
                                        <div style="background:#d8dde5;padding:10px;font-size: 12px;border-radius:.25rem;margin-bottom:15px;" v-if="settingsFromWeebly.settings.backgroundVideo">
                                            <em>Video background will be visible in Weebly editor and on your live site.</em>
                                        </div>
                                        <div class="setting">
                                            <label for="backgroundVideoChild">Video url (Youtube or Vimeo)</label>
                                            <b-form-input id="backgroundVideoChild" type="text" v-model="childBlock.backgroundVideoUrl" size="sm" @change="activateParallax" />
                                        </div>

                                        <!-- parallax speed -->
                                        <div class="setting">
                                            <b-form-group>

                                                <label for="flexchild-parallaxspeed-input">Parallax speed: <span v-b-tooltip.hover.top title="set value to '1' to deactivate parallax on video"><i class="far fa-question-circle"></i></span></label>
                                                
                                                <b-input-group size="sm">
                                                    <b-form-input id="flexchild-parallaxspeed-input" type="number" v-model="childBlock.parallaxSpeed" min="-1.0" max="2.0" step="0.1" @change="activateParallaxToggle" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>
                                        <!-- start video time -->
                                        <!-- <div class="setting">
                                            <b-form-group>

                                                <label for="flexchildblock-starttime-input">Start time in seconds: <span v-b-tooltip.hover.top title="Start time in seconds when video will be started (this value will be applied also after loop)."><i class="far fa-question-circle"></i></span></label> 
                                                
                                                <b-input-group size="sm">
                                                    <b-form-input id="flexchildblock-starttime-input" type="number" v-model="childBlock.childVideoStartTime" min="0"  step="1" @change="activateParallaxToggle" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>   -->
                                    </div><!-- v-if="childBlock.backgroundVideoChild" -->

                                    <div v-if="!childBlock.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border desktop
                                            </div>
                                            <i class="fas unlink-border-radius fa-link" @click="childBlock.useIndividualBorder = !childBlock.useIndividualBorder" v-b-tooltip.hover.top title="Set borders individually"></i>

                                            <!--  general border width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalborderwidth-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalborderwidth-input" type="number" v-model="childBlock.borderGeneralWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  general border color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocks elementRef="borderGeneralColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="arrayIndex" />
                                            </div>

                                            <!-- border type general -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="childBlock.borderGeneralStyle" size="sm">

                                                        <option value="solid">Solid</option>

                                                        <option value="dotted">Dotted</option>

                                                        <option value="dashed">Dashed</option>

                                                        <option value="double">Double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>

                                        </div><!-- border-group -->
                                        
                                    </div><!-- v-if="!childBlock.useIndividualBorder" -->

                                    <div v-if="childBlock.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border top desktop
                                            </div>
                                            <i class="fas unlink-border-radius fa-unlink" @click="childBlock.useIndividualBorder = !childBlock.useIndividualBorder" v-b-tooltip.hover.top title="Set borders equally"></i>
                                    
                                            <!--  border top width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalborderwidth-input">Border top width desktop:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalborderwidth-input" type="number" v-model="childBlock.borderTopWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border top color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocks elementRef="borderTopColor" theColorPicker="allpickers" colorPickerName="Border top color:" :indexNr="arrayIndex" />
                                            </div>

                                            <!-- border top type -->
                                            <div class="setting">
                                                <b-form-group label="Border top style:">

                                                    <b-form-select v-model="childBlock.borderTopStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>

                                        </div><!-- border-group -->

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border right desktop
                                            </div>

                                            <!--  border right width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderRightWidthDesk-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderRightWidthDesk-input" type="number" v-model="childBlock.borderRightWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border right color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocks elementRef="borderRightColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="arrayIndex" />
                                            </div>

                                            <!-- border right type -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="childBlock.borderRightStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>
                                        
                                        </div><!-- border-group -->

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border bottom desktop
                                            </div>
                                            <!--  border bottom width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderBottomWidth-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderBottomWidth-input" type="number" v-model="childBlock.borderBottomWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border bottom color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocks elementRef="borderBottomColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="arrayIndex" />
                                            </div>

                                            <!-- border bottom type -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="childBlock.borderBottomStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>

                                        </div><!-- border-group -->

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border left desktop
                                            </div>
                                            
                                            <!--  border left width DESKTOP -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderLeftWidth-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderLeftWidth-input" type="number" v-model="childBlock.borderLeftWidth" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border left color -->
                                            <div class="setting">
                                                <Mycolorpickerchildblocks elementRef="borderLeftColor" theColorPicker="allpickers" colorPickerName="Color:" :indexNr="arrayIndex" />
                                            </div>

                                            <!-- border left type -->
                                            <div class="setting">
                                                <b-form-group label="Style:">

                                                    <b-form-select v-model="childBlock.borderLeftStyle" size="sm">

                                                        <option value="solid">solid</option>

                                                        <option value="dotted">dotted</option>

                                                        <option value="dashed">dashed</option>

                                                        <option value="double">double</option>

                                                    </b-form-select>

                                                </b-form-group>
                                            </div>
                                        </div><!-- border-group -->

                                    </div><!-- v-if="childBlock.useIndividualBorder" -->

                                    <!-- border radius -->
                                    <div class="border-group">

                                        <div class="border-group--title">
                                            Border radius desktop
                                        </div>
                                        <i class="fas unlink-border-radius fa-link" @click="childBlock.useIndividualBorderRadius = !childBlock.useIndividualBorderRadius" v-b-tooltip.hover.top title="Set border radius individually"></i>

                                        <!--  general border radius DESKTOP -->
                                        <div class="setting" v-if="!childBlock.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-generalborderradius-input">Radius:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-generalborderradius-input" type="number" v-model="childBlock.borderRadiusGeneral" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>

                                        <!--  general border radius top left DESKTOP -->
                                        <div class="setting" v-if="childBlock.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiuslefttop-input">Top left:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiuslefttop-input" type="number" v-model="childBlock.borderTopLeftRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>  

                                        <!--  general border radius top right DESKTOP -->
                                        <div class="setting" v-if="childBlock.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiusrighttop-input">Top right:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiusrighttop-input" type="number" v-model="childBlock.borderTopRightRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>  

                                        <!--  general border radius top left DESKTOP -->
                                        <div class="setting" v-if="childBlock.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiusbottomright-input">Bottom right:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiusbottomright-input" type="number" v-model="childBlock.borderBottomRightRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>  

                                        <!--  general border radius top left DESKTOP -->
                                        <div class="setting" v-if="childBlock.useIndividualBorderRadius">
                                            <b-form-group>

                                                <label for="child-borderradiusbottomleft-input">Bottom left:</label>
                                                
                                                <b-input-group append="px" size="sm">
                                                    <b-form-input id="child-borderradiusbottomleft-input" type="number" v-model="childBlock.borderBottomLeftRadius" min="0" />
                                                </b-input-group>

                                            </b-form-group>
                                        </div>   

                                    </div><!-- border-group -->

                                </div>
                            </div>

                            <!-- dimensions settings -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>dimensions</h6>
                                </div>
                                <div class="setting-section-content">

                                    <div v-if="!childBlock.hideOnDesktop">
                                        <!-- child width -->
                                        <div class="setting">
                                            <b-form-group>

                                                <label>Max width desktop child:</label>
                                                <b-form-select :id="'maxWidth-child-desktop-'+childBlock.blockId" v-model="childBlock.maxWidthDesktop" size="sm">
                                                    <option value="8.333333">1 / 12</option>
                                                    <option value="16.666667">2 / 12</option>
                                                    <option value="25">3 / 12</option>
                                                    <option value="33.333333">4 / 12</option>
                                                    <option value="41.666667">5 / 12</option>
                                                    <option value="50">6 / 12</option>
                                                    <option value="58.333333">7 / 12</option>
                                                    <option value="66.666667">8 / 12</option>
                                                    <option value="75">9 / 12</option>
                                                    <option value="83.333333">10 / 12</option>
                                                    <option value="91.666667">11 / 12</option>
                                                    <option value="100">12 / 12</option>
                                                </b-form-select>

                                            </b-form-group>
                                        </div>

                                    </div><!-- v-if="!childBlock.hideOnDesktop" -->

                                    <!-- horizontal padding child DESKTOP -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-horizontalpadding-input">Horizontal padding desktop:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-horizontalpadding-input" type="number" v-model="childBlock.horizontalPad" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>      

                                    <!-- vertical padding child DESKTOP -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-verticalpadding-input">Vertical padding desktop:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-verticalpadding-input" type="number" v-model="childBlock.verticalPad" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>

                                </div><!-- setting-section-content -->
                            </div>

                            <!-- link block -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>LINK</h6>
                                </div>
                                <div class="setting-section-content">

                                    <!-- use link -->
                                    <div class="setting" v-if="clientPro=='PRO'">
                                        <b-form-checkbox switch v-model="childBlock.useLink" name="use-link-image">
                                            Link block
                                        </b-form-checkbox>
                                    </div>

                                    <!-- use link free -->
                                    <div class="setting pro-setting" v-if="clientPro!=='PRO'" v-b-tooltip.hover.top title="PRO feature" v-b-modal="'upgrades-modal'">
                                        <b-form-checkbox switch v-model="childBlock.useLink" name="use-link-image">
                                            Link block
                                        </b-form-checkbox>
                                    </div>

                                    <!-- image url -->
                                    <div class="setting" v-if="childBlock.useLink">
                                        <b-form-group label="Image link:" label-for="button-url-input">

                                            <!-- extra settings toggle -->
                                            <span class="input-right-setting-icon button-target-settings-box-trigger" @click="targetSettingsBox = !targetSettingsBox" v-b-tooltip.hover.top title="Link Options">
                                                <i class="fas fa-cog"></i>
                                            </span>

                                            <b-form-input id="button-url-input" type="text"  class="input-with-right-setting-icon" v-model="childBlock.link" size="sm" />

                                        </b-form-group>
                                        <div v-show="targetSettingsBox">

                                        <!-- button target -->
                                        <b-form-radio-group label="Open link in:" label-for="button-target-select" v-model="childBlock.target" id="button-target-select">
                                                
                                                <b-form-radio value="_self" name="button-target">Open in same window</b-form-radio>

                                                <b-form-radio value="_blank" name="button-target">Open in new window</b-form-radio>

                                            </b-form-radio-group>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div><!-- v-show="deviceStylesSetttings.desktopStyles" -->

                        <div v-show="deviceStylesSetttings.tabletStyles">

                            <!-- visibility -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>visibility</h6>
                                </div>
                                <div class="setting-section-content">
                                    <!-- checkbox set hide tablet -->
                                    <div class="setting">
                                        <b-form-checkbox switch v-model="childBlock.hideOnTablet" name="hide-childblock-on-tablet">
                                            Hide for tablet
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>

                            <!-- styles -->
                            <div class="setting-section" v-if="!childBlock.hideOnTablet">
                                <div class="setting-section-title">
                                    <h6>styles</h6>
                                </div>
                                <div class="setting-section-content">
                                    <div v-if="!childBlock.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border tablet
                                            </div>
                                            <!--  general border width TABLET -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalborderwidthtablet-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalborderwidthtablet-input" type="number" v-model="childBlock.borderGeneralWidthTablet" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div> 
                                        </div><!-- border group -->

                                    </div><!-- v-if="!childBlock.useIndividualBorder" -->

                                    <div v-if="childBlock.useIndividualBorder">
                                        
                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border tablet
                                            </div>

                                            <!--  border top width TABLET -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalbordertopwidthtablet-input">Width border top:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalbordertopwidthtablet-input" type="number" v-model="childBlock.borderTopWidthTablet" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border right width TABLET -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderRightWidthTablet-input">Width border right:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderRightWidthTablet-input" type="number" v-model="childBlock.borderRightWidthTablet" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border bottom width TABLET -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderBottomWidthTablet-input">Width border bottom:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderBottomWidthTablet-input" type="number" v-model="childBlock.borderBottomWidthTablet" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border left width TABLET -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderLeftWidthTablet-input">Width border left:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderLeftWidthTablet-input" type="number" v-model="childBlock.borderLeftWidthTablet" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>  

                                        </div><!-- border group --> 

                                    </div><!-- v-if="childBlock.useIndividualBorder" -->
                                </div>
                            </div>

                            <!-- styles -->
                            <div class="setting-section" v-if="!childBlock.hideOnTablet">
                                <div class="setting-section-title">
                                    <h6>dimensions</h6>
                                </div>
                                <div class="setting-section-content">
                                    <!-- width block -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label>Max width tablet child:</label>
                                            <b-form-select :id="'maxWidth-child-desktop-'+childBlock.blockId" v-model="childBlock.maxWidthTablet" size="sm">
                                                <option value="8.333333">1/12</option>
                                                <option value="16.666667">2/12</option>
                                                <option value="25">3/12</option>
                                                <option value="33.333333">4/12</option>
                                                <option value="41.666667">5/12</option>
                                                <option value="50">6/12</option>
                                                <option value="58.333333">7/12</option>
                                                <option value="66.666667">8/12</option>
                                                <option value="75">9/12</option>
                                                <option value="83.333333">10/12</option>
                                                <option value="91.666667">11/12</option>
                                                <option value="100">12/12</option>
                                            </b-form-select>

                                        </b-form-group>
                                    </div>

                                    <!-- horizontal padding child TABLET -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-horizontalpadding-input">Horizontal padding tablet:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-horizontalpadding-input" type="number" v-model="childBlock.horizontalPadTablet" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>    

                                    <!-- vertical padding child TABLET -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-verticalpadding-input">Vertical padding tablet:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-verticalpadding-input" type="number" v-model="childBlock.verticalPadTablet" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>
                                </div>
                            </div>

                        </div><!-- v-show="deviceStylesSetttings.tabletStyles" -->

                        <div v-show="deviceStylesSetttings.mobileStyles">

                            <!-- visibility -->
                            <div class="setting-section">
                                <div class="setting-section-title">
                                    <h6>visibility</h6>
                                </div>
                                <div class="setting-section-content">
                                    <!-- checkbox set hide phone -->
                                    <div class="setting">
                                        <b-form-checkbox switch v-model="childBlock.hideOnPhone" name="hide-childblock-on-phone">
                                            Hide for phone
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>

                            <!-- styles -->
                            <div class="setting-section" v-if="!childBlock.hideOnPhone">
                                <div class="setting-section-title">
                                    <h6>styles</h6>
                                </div>

                                <div class="setting-section-content">

                                    <div v-if="!childBlock.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border phone
                                            </div>
                                            <!--  general border width TABLET -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalborderwidthPhone-input">Width:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalborderwidthPhone-input" type="number" v-model="childBlock.borderGeneralWidthPhone" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div> 
                                        </div><!-- border group -->

                                    </div><!-- v-if="!childBlock.useIndividualBorder" -->

                                    <div v-if="childBlock.useIndividualBorder">

                                        <div class="border-group">

                                            <div class="border-group--title">
                                                Border phone
                                            </div>
                                    
                                            <!--  border top width PHONE -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-generalbordertopwidthPhone-input">Width border top:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-generalbordertopwidthPhone-input" type="number" v-model="childBlock.borderTopWidthPhone" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border right width PHONE -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderRightWidthPhone-input">Width border right:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderRightWidthPhone-input" type="number" v-model="childBlock.borderRightWidthPhone" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border bottom width PHONE -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderBottomWidthPhone-input">Width border bottom:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderBottomWidthPhone-input" type="number" v-model="childBlock.borderBottomWidthPhone" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>   

                                            <!--  border left width PHONE -->
                                            <div class="setting">
                                                <b-form-group>

                                                    <label for="flexchild-borderLeftWidthPhone-input">Width border left:</label>
                                                    
                                                    <b-input-group append="px" size="sm">
                                                        <b-form-input id="flexchild-borderLeftWidthPhone-input" type="number" v-model="childBlock.borderLeftWidthPhone" min="0" />
                                                    </b-input-group>

                                                </b-form-group>
                                            </div>  

                                        </div><!-- border group -->

                                    </div><!-- v-if="childBlock.useIndividualBorder" -->

                                </div>
                            </div>

                            <!-- dimensions -->
                            <div class="setting-section" v-if="!childBlock.hideOnPhone">
                                <div class="setting-section-title">
                                    <h6>dimensions</h6>
                                </div>
                                
                                <div class="setting-section-content">
                                    <!-- max width on phone -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label>Max width phone child:</label>
                                            <b-form-select :id="'maxWidth-child-desktop-'+childBlock.blockId" v-model="childBlock.maxWidthPhone" size="sm">
                                                <option value="8.333333">1/12</option>
                                                <option value="16.666667">2/12</option>
                                                <option value="25">3/12</option>
                                                <option value="33.333333">4/12</option>
                                                <option value="41.666667">5/12</option>
                                                <option value="50">6/12</option>
                                                <option value="58.333333">7/12</option>
                                                <option value="66.666667">8/12</option>
                                                <option value="75">9/12</option>
                                                <option value="83.333333">10/12</option>
                                                <option value="91.666667">11/12</option>
                                                <option value="100">12/12</option>
                                            </b-form-select>

                                        </b-form-group>
                                    </div>

                                    <!-- horizontal padding child PHONE -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-horizontalpadding-input">Horizontal padding phone:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-horizontalpadding-input" type="number" v-model="childBlock.horizontalPadPhone" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>      

                                    <!-- vertical padding child PHONE -->
                                    <div class="setting">
                                        <b-form-group>

                                            <label for="flexchild-verticalpadding-input">Vertical padding phone:</label>
                                            
                                            <b-input-group append="px" size="sm">
                                                <b-form-input id="flexchild-verticalpadding-input" type="number" v-model="childBlock.verticalPadPhone" min="0" />
                                            </b-input-group>

                                        </b-form-group>
                                    </div>
                                </div>
                            </div>

                        </div><!-- v-show="deviceStylesSetttings.mobileStyles" -->

                    </div>

                </div>
            </vue-draggable-resizable>

        </transition>
        {conblock{{settingsToShow}}:content}
        <a v-if="childBlock.useLink" class="bundle-block-link" :href="childBlock.link" :target="childBlock.target"></a>

    </div>

</template>

<script>
import draggable from 'vuedraggable'
import Mycolorpicker from '../Mycolorpicker'
import Mycolorpickerchildblocks from '../Mycolorpickerchildblocks'

import VueDraggableResizable from 'vue-draggable-resizable'

import axios from 'axios'

export default {

    props: ['settingsToShow', 'arrayIndex', 'childBlock'],

    name: 'BlocksChild',


    data() {
        return {
            // show child block action buttons: settings + delete
            showBlockActionButtons: false,
            showChildSettings: false,
            targetSettingsBox: false,

            confirmBlockDelete: false,

            colors: '#fff',
            indexId: 1,
            desktopSettings: true,
            tabletSettings: false,
            mobileSettings: false,

            selectedFile : null,

            curSettings: '',
            curIcon: '',

            setBoxWidth: 353,
            setBoxHeight: 403,

            centerPositionSettingsBoxX: null,
            centerPositionSettingsBoxY: null
        }
    },

    components: {
        draggable,

        'vue-draggable-resizable': VueDraggableResizable,

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        },

        // color picker
        Mycolorpicker,
        Mycolorpickerchildblocks
        

    },

    methods: {

        getClosestParent (elem, selector) {

            // Element.matches() polyfill
            if (!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function(s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) {}
                        return i > -1;
                    };
            }

            // Get the closest matching element
            for ( ; elem && elem !== document; elem = elem.parentNode ) {
                if ( elem.matches( selector ) ) return elem;
            }
            return null;

        },

        activateParallaxToggle() {
            if(event.target.checked === true) {
                this.activateParallax()
            }
        },

        activateParallax() {
            console.log('it was changed')
            if(document.querySelector('.jarallax')){
                jarallax(document.querySelectorAll('.jarallax'), 'destroy');
                console.log('jarallax destroyed now')
            }
            setTimeout(()=>{
                if(document.querySelector('.jarallax')){
                    jarallax(document.querySelectorAll('.jarallax'))
                    console.log('jarallax should be activate now')
                }
            },2500)
            console.log('we will need to revise reload of video here')
                
        },

        addClickSettingsBox() {
            
            const el = this.curSettings
            const icon = this.curIcon
            let target = event.target

			if((el !== target && !el.contains(target)) && icon !== target) {

                setTimeout( () => {
                    document.removeEventListener('click', this.addClickSettingsBox)
                    // hide child settings
                    this.showChildSettings = false
                },150)
               
            } else {
                console.log(' target so leave settings')
            }

        },

        showChildBlockSettings(settingsToShow) {


            let curEvent = event.target
            setTimeout( () => {
                this.curSettings = document.getElementById('child-block-settings-'+settingsToShow)
                this.curIcon = curEvent
            },500)
            

            let guide = document.getElementById('child-block-settings-'+settingsToShow+'-guide')

            console.log('offset left guide ',guide.offsetLeft)
            console.log('offset top guide ',guide.offsetTop)

            this.centerPositionSettingsBoxX = guide.offsetLeft
            this.centerPositionSettingsBoxY = guide.offsetTop

            console.log(settingsToShow)

            // show child settings
            this.showChildSettings = true
            // add event listener
            setTimeout( ()=> {
                document.addEventListener('click', this.addClickSettingsBox)
            },1000)
            
        },

        deleteChildBlock(arrayIndex) {

            console.log('before ',this.$store.state.weeblySettings.settings.childBlocks)
            this.$store.state.weeblySettings.settings.childBlocks.splice(this.arrayIndex, 1)

            console.log('after ',this.$store.state.weeblySettings.settings.childBlocks)

        },

        onFileSelected(index) {

            this.selectedFile = event.target.files[0]

            let fd = new FormData();
            fd.append('image', this.selectedFile)
            axios.post('/weebly/app_in_process/buttons/imageUpload.php', fd, {
                // headers: {
                //     'Content-Type': 'multipart/form-data'
                // }
            })
            .then(res => {
                console.log(res)
                // this.imageBg = 'https://appjustable.com/weebly/app_in_process/buttons/'+res.data

                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChildSet = 'https://appjustable.com/weebly/app_in_process/buttons/'+res.data

            }).catch( error => {
                console.log(error);
            })

            // check if parallax was activated and if so, do run it on this element
            if(this.$store.state.weeblySettings.settings.childBlocks[index].useParallax === true){
                this.activateParallax()
            }

        },

        useBackgroundColor(index) {
            if(event.target.checked === true) {
                this.activateParallax()
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundColorChild = true
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundVideoChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].useParallax = false
            } else {
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundColorChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChild = true
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundVideoChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].useParallax = false
            }
            
        },

        useBackgroundImage(index) {
            if(event.target.checked === true) {
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundColorChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChild = true
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundVideoChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].useParallax = false
            } else {
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundColorChild = true
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundVideoChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].useParallax = false
            }
        },

        useBackgroundVideo(index) {
            if(event.target.checked === true) {
                this.$store.state.weeblySettings.settings.childBlocks[index].useParallax = true
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundColorChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundVideoChild = true
                this.activateParallax()
            } else {
                this.$store.state.weeblySettings.settings.childBlocks[index].useParallax = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundColorChild = true
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundImageChild = false
                this.$store.state.weeblySettings.settings.childBlocks[index].backgroundVideoChild = false
            }
        },

        removeActiveFromBlock() {
            console.log('remove now please')
            // remove active class from element
            if( document.querySelector('.block-child.active') ) {
                document.querySelector('.block-child.active').classList.remove('active')
            }

            // remove active class from selected block
            if( document.querySelector('.child-block-settings.active') ) {
                document.querySelector('.child-block-settings.active').classList.remove('active')
            }
        },

        // add child + its settings
        addToChildArray() {

            console.log(this.$store.state.weeblySettings.settings.childBlocks);

            this.removeActiveFromBlock()

            this.$store.state.weeblySettings.settings.childBlocks.push(
                {
                    blockId: 'blocks-flexchild-'+Math.random().toString(36).substr(2, 16),
                    childBackground: '#f1f1f1',
                    maxWidthDesktop: '100',
                    maxWidthTablet: null,
                    maxWidthPhone: null,
                    hideOnDesktop: false,
                    hideOnTablet: false,
                    hideOnPhone: false,
                    horizontalPad: 15,
                    verticalPad: 15,
                    horizontalPadTablet: null,
                    verticalPadTablet: null,
                    horizontalPadPhone: null,
                    verticalPadPhone: null,

                    borderGeneralColor: '#cccccc',
                    borderGeneralStyle: 'solid',
                    borderGeneralWidth: 1,

                    useIndividualBorder: false,

                    borderTopColor: '#cccccc',
                    borderTopStyle: 'solid',
                    borderTopWidth: 1,
                    
                    borderRightColor: '#cccccc',
                    borderRightStyle: 'solid',
                    borderRightWidth: 1,
                    
                    borderBottomColor: '#cccccc',
                    borderBottomStyle: 'solid',
                    borderBottomWidth: 1,
                    
                    borderLeftColor: '#cccccc',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 1,

                    borderGeneralWidthTablet: null,
                    borderTopWidthTablet: null,
                    borderRightWidthTablet: null,
                    borderBottomWidthTablet: null,
                    borderLeftWidthTablet: null,

                    borderGeneralWidthPhone: null,
                    borderTopWidthPhone: null,
                    borderRightWidthPhone: null,
                    borderBottomWidthPhone: null,
                    borderLeftWidthPhone: null,

                    backgroundColorChild: true,
                    backgroundImageChild: false,
                    backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',
                    useBackgroundVideo: false,
                    backgroundVideoUrl: 'https://www.youtube.com/watch?v=-SJXOTtdTDE&list=PLx-qGAzjv13c00FYZMLAJm65WjsT3ZmDR&index=3',
                    xAxisPosition: 'center',
                    yAxisPosition: 'center',
                    useParallax: true,
                    parallaxSpeed: 0.2
                }
            )

            // add active class to newly added block
            // settings
            let newActive = this.$store.state.weeblySettings.settings.childBlocks.length - 1
            let newActiveClass = '.child-block-settings-'+this.$store.state.weeblySettings.settings.childBlocks[newActive].blockId
            let newIdActive = this.$store.state.weeblySettings.settings.childBlocks[newActive].blockId

            setTimeout(()=> {
                document.querySelector(newActiveClass).classList.add('active')
                document.getElementById(newIdActive).classList.add('active')
            },1000)
            

            // settings

        },

        // show desktop settings
        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--mini i');
            icons.forEach(icon => {
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            // set devices to false
            this.desktopSettings = false
            this.tabletSettings = false
            this.mobileSettings = false

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
            }

        }

    },

    computed: {
        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },
        childBlockArray() {
            return this.$store.state.weeblySettings.settings.childBlocks
        },
        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },
        // block guide
        showBlockChildSettingsGuide() {
            return this.$store.state.showBlockChildSettingsGuide
        },

        clientPro() {
            return this.$store.state.clientInfo.clientAccount
        }
    },

    mounted() {

        // // add active class to element
        // document.getElementById(this.settingsToShow).classList.add('active');

        // // add active class for settings
        // setTimeout(() => {
        //     document.querySelector('.child-block-settings.child-block-settings-'+this.settingsToShow).classList.add('active')
        // },1000)

        // console.log('guide store ',this.$store.state.showBlockChildSettingsGuide)
   
        
    }
}

</script>

<style lang="less">
@import '../../../../less/colors.less';

.settings-box-child-guide {
    position: absolute;
    // top: calc(~"100% + 15px");
    top: 30px;
    left: 50%;
    margin-left: -175px;
    width: 350px;   
    height: 0px;
    opacity: 0;
    z-index: -2;
    overflow: hidden;
}

.settings-box-child {
    position: absolute;
    // top: calc(~"100% + 15px");
    // left: 50%;
    // transform: translateX(-50%);
    width: 350px;
    background: #fff;
    border: 1px solid @border_grey_dark;
    z-index: 100;
    border-radius: .25rem;
    margin-bottom: 30px;
    box-shadow: 0 3px 17px fade(@title_grey, 20%);

    &:after, &:before {
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    &:after {
        border-color: rgba(242, 243, 245, 0);
        border-bottom-color: #fff;
        border-width: 8px;
        margin-left: -8px;
    }
    &:before {
        border-color: rgba(187, 199, 213, 0);
        border-bottom-color: #bbc7d5;
        border-width: 9px;
        margin-left: -9px;
    }

    .settings-box-child-inner {
        overflow-y: auto;
        height: 350px;
        padding: 15px;
        font-size: 12px;
        width: 350px;
        background: @light_blue;

        label {
            font-weight: 700;
            color: @title_grey;
        }

        .color-picker-group .color-picker-tool {
            max-width: 220px;
            left: 50%;
            transform: translateX(-50%)

        }
    }

    .settings-box-child-title {
        h6 {
            border-bottom: 1px solid @border_grey_medium;
            padding: 0 15px;
            line-height: 50px;
            margin:0;
            background: #fff;
            border-radius: 0.25rem 0.25rem 0 0;
            font-size: 15px;
            font-weight: 700;
            text-align: center;
            text-transform: capitalize;
            cursor: move;
            cursor: grab;

            &:focus, &:active {
                cursor: move;
                cursor: grabbing;
            }
        }
    }

    .setting {
        margin-bottom: 30px;
        background: #fff;
        padding: 7px 0;
        border: 1px solid @border_grey_medium;
    }
}

.block-child {
    min-height: 100px;
    background: #f8f8f8;
    position: relative;
    font-size: 0;
}

.access-settings-tooltip, .delete-block-tooltip {
    background: @action_blue;
    padding: 7px;
    font-weight: 700;
}

.delete-block-tooltip {
    background: @warning_red;
}

// .block-child.active:before {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     background: fade(@action_blue, 80%);
//     content: '';
// }

.settings-child-icon {
    position: absolute;
    top: -7px;
    left: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @action_blue;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@action_blue, 85%);
    }
}

.block-drag-handle, .block-drag-handle-disabled {
    position: absolute;
    top: -7px;
    left: 50%;
    height: 20px;
    width: 34px;
    margin-left: -17px;
    background: #fff;
    cursor: move;
    z-index: 10;
    border-radius: .25rem;
    text-align: center;
    border: 1px solid @action_blue;

    i {
        font-size: 10px;
        line-height: 20px;
        color: @action_blue;
    }
}

.block-drag-handle-disabled {
    cursor: default;
    cursor: no-drop;
    opacity: .5;
}

.delete-child-icon {
    z-index: 10;
    position: absolute;
    top: -7px;
    right: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @warning_red;
    border-radius: .25rem;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }

    &:hover {
        background: fade(@warning_red, 85%);
    }
}
.child-block-settings {
    display: none;
}
.child-block-settings.active {
    display: block;
}

.sortable-chosen {
    opacity: .7;
    border: 1px solid @action_blue;
}
.ghost-block {
    background: @action_blue!important;
    opacity: .2;
}
// .ghost-block {
//     background: red;
// }

.setting-section {
    margin-bottom: 30px;

    .setting-section-title {
        h6 {
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: .05em;
            font-weight: 400;
            padding-left: 7px;
        }
    }

    .setting-section-content {
        padding: 15px 7px 0;
        background: #fff;
        border: 1px solid @border_grey_medium;

        .setting {
            border: 0;
            margin-bottom: 15px;

            .form-group {
                margin-bottom: 0;
            }

            .custom-control-label {
                font-weight: 400;
            }

        }

        .setting-toggle-group {

            .custom-control.custom-switch {
                margin-bottom: 7px;
            }
        }

    }
}

.confirm-block-deletion {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 350px;
    background: #fff;
    border: 1px solid @shark_light;
    z-index: 1000;
    font-size: 12px;
    border-radius: .25rem;
    text-align: center;
    box-shadow: 0 4px 10px fade(@shark_light, 25%);

    h4 {
        font-size: 20px;
        font-weight: 400;
        background: @shark_light;
        color: #fff;
        padding: 10px;
    }

    p {
        font-size: 13px;
        padding: 15px;
        margin: 0;
    }

    span {
        margin: 5px 5px 15px;
        display: inline-block;
        font-weight: 700;
        cursor: pointer;
        color: @text_grey;
        font-size: 13px;
        padding: 7px 12px;
        background: fade(@shark_light,12%);
        border-radius: .25rem;

        &:hover {
            opacity: .9;
        }

        i {
            margin-right: 7px;
        }
    }

    .confirm-delete-block-action {
        background: @warning_red;
        color: #fff;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/blocks/BlocksChild.vue